import { Link } from "react-router-dom";
import { ArrowRight, Compass, Focus, Flag, Clock3 } from "lucide-react";
import { useApp } from "../context";
import { PROTOCOLS } from "../lib/practice/protocols";

export function HomePage() {
  const { state } = useApp();
  const recent = [...(state.progress.practiceReceipts || [])]
    .reverse()
    .find((r) => r.status === "completed");
  return (
    <div className="calm-page home-page">
      <header className="page-intro">
        <p className="eyebrow">A little space for you</p>
        <h1>One small step is enough.</h1>
        <p>
          Take a moment to settle, find your focus, or prepare for what’s next.
        </p>
      </header>
      <section className="practice-hero" aria-labelledby="recommended-title">
        <div className="activity-meta">
          <Compass size={22} aria-hidden="true" />
          <span>A gentle place to start</span>
          <span className="duration">
            <Clock3 size={15} aria-hidden="true" />2 min
          </span>
        </div>
        <h2 id="recommended-title">Come back to the present.</h2>
        <p>
          Notice a few things around you. Breathe naturally and take it at your
          own pace.
        </p>
        <Link className="btn btn-primary" to="/practice?purpose=settle">
          Start a 2-minute practice <ArrowRight size={18} aria-hidden="true" />
        </Link>
        <span className="quiet-note">
          You can pause or stop whenever you need.
        </span>
      </section>
      <section aria-labelledby="another-way">
        <h2 className="section-title" id="another-way">
          Need something different?
        </h2>
        <div className="intent-grid">
          <Link className="intent-card" to="/practice?purpose=focus">
            <Focus size={22} aria-hidden="true" />
            <div>
              <h3>Find my focus</h3>
              <p>Choose one manageable next step.</p>
            </div>
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
          <Link className="intent-card" to="/practice?purpose=prepare">
            <Flag size={22} aria-hidden="true" />
            <div>
              <h3>Prepare for a challenge</h3>
              <p>Make a plan for a difficult moment.</p>
            </div>
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </div>
      </section>
      {recent ? (
        <div className="recent-practice">
          <span>
            Last completed:{" "}
            {PROTOCOLS.find((p) => p.id === recent.protocolId)?.title ||
              "Your practice"}
          </span>
          <Link to="/progress">View your progress</Link>
        </div>
      ) : (
        <p className="home-footnote">
          No score to chase. Explore lessons, games, and journaling when you
          feel ready.
        </p>
      )}
      <Link className="text-link" to="/explore">
        Explore all activities <ArrowRight size={16} aria-hidden="true" />
      </Link>
    </div>
  );
}
